import { appQueryClient } from '@libs/data-access/queries'

export const membershipContractCacheKeys = {
  contracts: queryParams => ['membership_contracts', queryParams],
  fetch_contracts_eligible_for_dpae: queryParams => [
    'fetch_contracts_eligible_for_dpae',
    queryParams
  ]
}

export const membershipContractInvalidations = {
  invalidateContracts: () => {
    appQueryClient.invalidateQueries({
      queryKey: membershipContractCacheKeys.contracts({})
    })
  },
  invalidateContractEligibleForDPAE: () => {
    appQueryClient.invalidateQueries({
      queryKey: membershipContractCacheKeys.fetch_contracts_eligible_for_dpae(
        {}
      )
    })
  }
}
